<script setup lang="ts">
  interface Props {
    primary: string;
    secondary: string;
    text: string;
    dark?: boolean;
  }

  const props = defineProps<Props>();

  // The preview paints its own surfaces so it shows the chosen mode whatever mode the admin
  // is browsing in.
  const SURFACES = {
    light: { page: '#fcfcfd', card: '#ffffff', ink: '#2f2f2f', border: '#e3e3e3' },
    dark: { page: '#121212', card: '#1e1e1e', ink: '#e8e8e8', border: '#3a3a3a' },
  };

  const surface = () => (props.dark ? SURFACES.dark : SURFACES.light);
</script>

<template>
  <div
    class="flex h-28 w-full overflow-hidden rounded-xl border text-[10px]"
    :style="{ backgroundColor: surface().page, borderColor: surface().border }"
    data-testid="theme-preview"
  >
    <div
      class="flex w-24 shrink-0 flex-col gap-1.5 p-2"
      :style="{ backgroundColor: primary, color: text }"
    >
      <span class="font-semibold">MENU</span>
      <span
        class="rounded px-1.5 py-0.5 text-white"
        :style="{ backgroundColor: secondary }"
      >Início</span>
      <span class="px-1.5">Dashboard</span>
      <span class="px-1.5">Homologação</span>
    </div>
    <div
      class="flex flex-1 flex-col gap-2 p-2"
      :style="{ color: surface().ink }"
    >
      <div
        class="rounded-md border px-2 py-1"
        :style="{ backgroundColor: surface().card, borderColor: surface().border }"
      >
        Documentos
      </div>
      <div class="flex items-center gap-2">
        <span
          class="rounded px-2 py-0.5 text-white"
          :style="{ backgroundColor: secondary }"
        >Enviar</span>
        <span
          class="rounded border px-2 py-0.5"
          :style="{ borderColor: secondary, color: secondary }"
        >Filtrar</span>
      </div>
    </div>
  </div>
</template>
